import React from "react";
import { Checkbox } from "react-materialize";
import { useNotify } from "context/NotifyContext";
import handleEvents from "components/notify/handleEvents";

export default function TrContent({ data, setData }) {
  const { filters, results, dispatch } = useNotify();
  const colspan = 8;
  let list = [];
  // console.log(results.data);
  for (const i in results?.data) {
    results.data[i].checkedRemove = filters?.removeItems?.[results.data[i].id]
      ? true
      : false;
    list.push(
      <tr key={"row-" + i}>
        <Feature.TdContent
          data={results.data[i]}
          index={i}
          filters={filters}
          dispatch={dispatch}
        />
      </tr>
    );
  }
  if (results?.data?.length === 0) {
    list.push(
      <tr key="row-1">
        <td colSpan={colspan}>No Data</td>
      </tr>
    );
  }
  return list;
}

const Feature = {};
Feature.TdContent = ({ data, index, filters, dispatch }) => {
  let td = [];
  td.push(
    <td key={"row-" + index + "-col-email"} className="text-center">
      <span className="text">{data?.email ?? "-"}</span>
    </td>
  );
  td.push(
    <td key={"row-" + index + "-col-fullname"} className="text-center">
      <span className="text">{data?.fullname ?? "-"}</span>
    </td>
  );
  td.push(
    <td key={"row-" + index + "-col-name"} className="text-center">
      <span className="text">{data?.name ?? "-"}</span>
    </td>
  );
  td.push(
    <td key={"row-" + index + "-col-senttype"} className="text-center">
      <span className="text">{data?.senttype ?? "-"}</span>
    </td>
  );
  td.push(
    <td key={"row-" + index + "-col-country"} className="text-center">
      <span className="text">{data?.country === "" ? "-" : data.country}</span>
    </td>
  );
  td.push(
    <td key={"row-" + index + "-col-department"} className="text-center">
      <span className="text">
        {data?.department === "" ? "-" : data.department}
      </span>
    </td>
  );
  td.push(
    <td key={"row-" + index + "-col-sale_office_code"} className="text-center">
      <span className="text">
        {data?.sale_office_code === "" ? "-" : data.sale_office_code}
      </span>
    </td>
  );
  td.push(
    <td key={"row-" + index + "-col-agent_code"} className="text-center">
      <span className="text">
        {data?.agent_name ? `${data.agent_name} (${data.agent_code})` : data?.agent_code ? `${data.agent_code}` : '-' }
      </span>
    </td>
  );
  td.push(
    <td
      key={"row-" + index + "-col-remove"}
      className="text-center"
      style={{ paddingLeft: "16px " }}
    >
      <Checkbox
        checked={data?.checkedRemove ?? false}
        filledIn
        id={"checkbox-remove-item-" + data.id}
        name="remove-item"
        className={"checkbox-remove-item"}
        label=""
        value={data.id.toString()}
        data-index={index}
        onChange={(evt) =>
          handleEvents.CheckboxRemoveItem.OnClick(evt, filters, dispatch)
        }
      />
    </td>
  );
  return td;
};
